import axios from "axios";
import { ApiClientsContext } from "apps/website/contexts/api";
import { IGetPostCheckoutChargesResponse } from "@api-clients/charges";

const MAX_RETRIES = 10;
const RETRY_DELAY_MS = 2000;
const HTTP_STATUS_OK = 200;

const sleep = (n: number) => new Promise((res) => {
  setTimeout(res, n);
});

async function attemptFetchPostCheckoutCharge(
  customerId: string,
  api: ApiClientsContext,
): Promise<IGetPostCheckoutChargesResponse | null> {
  try {
    const res = await api.Charges.getPostCheckoutCharges(customerId);
    return res;
  } catch (e) {
    if (axios.isAxiosError(e) && e?.response?.status === HTTP_STATUS_OK) {
      console.error(`axiosError: failed to get customer data for [katkinCustomerId=${customerId}]`, e);
      return null;
    }

    if (!axios.isAxiosError(e)) {
      console.error(`failed to get customer data for [katkinCustomerId=${customerId}]`, e);
      return null;
    }

    console.error(`axiosError: bad response when getting customer data for [katkinCustomerId=${customerId}], retrying...`, e);
    throw e;
  }
}

export async function fetchPostCheckoutChargeWithRetry(
  customerId: string,
  api: ApiClientsContext,
): Promise<IGetPostCheckoutChargesResponse | null> {
  let retries = MAX_RETRIES;

  while (retries > 0) {
    try {
      return await attemptFetchPostCheckoutCharge(customerId, api);
    } catch {
      await sleep(RETRY_DELAY_MS);
      retries -= 1;
    }
  }

  return null;
}
